/// <reference path="./types.d.ts" />
import { AiMotuEngine } from './dist/ai-motu-sdk.es.js'
import './dist/dist-sdk.css'
import { saveTemplate, uploadfile, loadTemplate, onDpiChange, opentagdialog, setfontList, uploadFont, AIsearchimg } from '../common/design'
import material from '../components/leftPanel/material/material.vue'
import image from '../components/leftPanel/image/image.vue'
import template from '../components/leftPanel/template/template.vue'
import text from '../components/text.vue'
import user from '../components/user.vue'
import tag from '../components/tag.vue'
// @ts-ignore
import createTag from '../components/topPanel/createTag.vue'
// import login from '../components/headerPanel/login.vue'
/**
 * 初始化 SDK 实例
 * @param container 容器选择器
 * @returns SDK 实例
 */
export const initSdk = async (container: string = '#page') => {
  return new AiMotuEngine({
    container,
    onDpiChange: onDpiChange,
    hostMethods: {
      loadTemplate: loadTemplate,  // 加载模板
      uploadfile: uploadfile,      // 上传文件
      saveTemplate: saveTemplate,  // 保存模板
    },
    dynamicDpi: true,
    fontconfig: {
      showFontUplaod: false,
      fontUpload: async (uploadList: any) => {
        await uploadFont(uploadList)
      },
    },
    showDownloadFile: true,
    leftPanel: [ // 自定义左侧导航栏
      { name: '模板', icon: 'moban', component: template },
      { name: '素材', icon: 'sucai', component: material },
      { name: '图片', icon: 'tupian', component: image },
      { name: '打标', icon: 'https://shanyin-design.oss-cn-hangzhou.aliyuncs.com/shanyin-design/image/user/1_1763617516163_定位_2.png', component: tag },
    ],
    headerPanel: [
      { position: 'RightFront', component: createTag },
    ],
    canvasContextMenu: [
      { position: 13, element: true, item: { text: '打标', handler: () => { opentagdialog() } } },
    ],
    toolbarActions: [
      {
        position: 3, element: {
          tooltip: 'AI搜图',
          icon: 'https://shanyin-design.oss-cn-hangzhou.aliyuncs.com/shanyin-design/image/user/4_1763694135316_扫码.png',
          iconClassName: 'text-18px color-#333',
          btnClass: 'h-[32px] w-[32px] rounded-3px mr-4px',
          type: 'Image',
          onClick: AIsearchimg
        }
      },
    ]



  })
}

/**
 * SDK 配置选项接口
 */
export interface SdkConfig {
  container?: string
  onDpiChange?: (dpi: number) => void
  hostMethods?: {
    loadTemplate?: Function
    uploadfile?: Function
    saveTemplate?: Function
  }
  fontconfig?: {
    showFontUplaod?: boolean
    fontUpload?: Function
    fontList?: Array<any>
  }
  dynamicDpi?: boolean
  showDownloadFile?: boolean
  leftPanel?: Array<any>,
  canvasContextMenu?: Array<any>,
}
// getDynamicDpi: true,
/**
 * 使用自定义配置初始化 SDK
 * @param config SDK 配置选项
 * @returns SDK 实例
 */
export const initSdkWithConfig = (config: SdkConfig) => {
  const defaultConfig: SdkConfig = {
    container: '#page',
    onDpiChange: onDpiChange,
    hostMethods: {
      loadTemplate: loadTemplate,
      uploadfile: uploadfile,
      saveTemplate: saveTemplate,
    },
    dynamicDpi: true,
    showDownloadFile: true,
    leftPanel: [
      { name: '素材', icon: 'sucai', component: material },
      { name: '图片', icon: 'tupian', component: image },
      { name: '模板', icon: 'moban', component: template },
      { name: '文字', icon: 'tupianbianjiqi_wenzi', component: text },
      { name: '我的', icon: 'wode', component: user },

    ],



  }

  // 合并配置
  const mergedConfig = { ...defaultConfig, ...config }

  return new AiMotuEngine(mergedConfig)
}

// 导出字体列表供外部使用
